import { ICreateSectionRequest } from 'core/model/interfaces/static-pages';
import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { handleErrorMessage, showNotificationError } from 'shared/utils/errors.utils';
import { notificationService } from 'shared/utils/notification.utils';
import { SLICE_NAMESPACE } from '../constants';
import { IStaticPagesState } from '../types';

export const createSection = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/createSection`,
  async (data: ICreateSectionRequest) => {
    try {
      await apiService.staticPages.createSection(data);
      notificationService.global.success('La sección se ha creado correctamente.');
    } catch (e) {
      const errorMessage = handleErrorMessage(e, 'Ocurrió un error al crear la sección.');
      showNotificationError(errorMessage);
      throw e;
    }
  },
);

export const createSectionReducer: TSliceExtraReducer<IStaticPagesState> = builder =>
  builder
    .addCase(createSection.pending, state => {
      state.form.loading = true;
      state.form.success = false;
    })
    .addCase(createSection.rejected, state => {
      state.form.loading = false;
      state.form.success = false;
    })
    .addCase(createSection.fulfilled, state => {
      state.form.loading = false;
      state.form.success = true;
    });
